"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.headersWithAuthToken = exports.headersWithBasicAuth = exports.headersWithTokenAndMnemonic = exports.headersWithToken = exports.basicHeaders = void 0;
function basicHeaders(clientName, clientVersion) {
    return {
        'content-type': 'application/json; charset=utf-8',
        'internxt-version': clientVersion,
        'internxt-client': clientName
    };
}
exports.basicHeaders = basicHeaders;
function headersWithToken(clientName, clientVersion, token) {
    var headers = basicHeaders(clientName, clientVersion);
    var extra = {
        Authorization: 'Bearer ' + token
    };
    return __assign(__assign({}, headers), extra);
}
exports.headersWithToken = headersWithToken;
function headersWithTokenAndMnemonic(clientName, clientVersion, token, mnemonic) {
    var headers = headersWithToken(clientName, clientVersion, token);
    var extra = {
        'internxt-mnemonic': mnemonic
    };
    return __assign(__assign({}, headers), extra);
}
exports.headersWithTokenAndMnemonic = headersWithTokenAndMnemonic;
function headersWithBasicAuth(clientName, clientVersion, auth) {
    var headers = basicHeaders(clientName, clientVersion);
    var token = auth.username + ":" + auth.password;
    var encodedToken = Buffer.from(token).toString('base64');
    var extra = {
        Authorization: 'Basic ' + encodedToken,
    };
    return __assign(__assign({}, headers), extra);
}
exports.headersWithBasicAuth = headersWithBasicAuth;
function headersWithAuthToken(clientName, clientVersion, token) {
    var headers = basicHeaders(clientName, clientVersion);
    return __assign(__assign({}, headers), { 'x-token': token });
}
exports.headersWithAuthToken = headersWithAuthToken;
